import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import eventBus from "../common/EventBus";

// APP COMPONENTS
import MerchantsIndex from "./restaurants";
import ResponsiveAppBar from "./appBar";
import { logoutUser } from "../store/actions/authSlice";

const Navbar = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const { isLoggedIn, user } = auth;

  const [intervalId, setIntervalId] = useState(null);
  const [intervalNeemoId, setIntervalNeemoId] = useState(null);
  const [restaurants, setRestaurants] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [restaurantModal, setRestaurantModal] = useState({ show: false });
  const [stats, setStats] = useState({
    restsSuccess: 0,
    restsClosed: 0,
    restsWarn: 0,
    restsFailure: 0,
  });

  const loadData = async () => {
    try {
      const newIntervalId = 0;
      const newIntervalNeemoId = 1;

      setIntervalId(newIntervalId);
      setIntervalNeemoId(newIntervalNeemoId);
    } catch (err) {
      console.log("Error NavBar LoadData: ", err);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      loadData();
    }, 10);

    const logoutHandler = () => {
      handleLogoutClick();
    };

    eventBus.on("logout", logoutHandler);

    return () => {
      clearTimeout(timer);
      if (intervalId !== null) clearInterval(intervalId);
      if (intervalNeemoId !== null) clearInterval(intervalNeemoId);
      eventBus.remove("logout", logoutHandler);
      window.onbeforeunload = null;
    };
  }, []);

  useEffect(() => {
    setRestaurants([]);
    setDrivers([]);
  }, [isLoggedIn]);

  const handleModal = () => {
    setRestaurantModal((prev) => ({
      show: !prev.show,
    }));
  };

  const handleLogoutClick = () => {
    dispatch(logoutUser());
  };

  return (
    <>
      {isLoggedIn && (
        <ResponsiveAppBar
          isLoggedIn={isLoggedIn}
          username={user ? user.username : null}
          userType={user ? user.user_type : null}
          logout={handleLogoutClick}
          handleRestaurants={handleModal}
        />
      )}

      {restaurantModal.show && (
        <MerchantsIndex show={restaurantModal.show} closeModal={handleModal} />
      )}
    </>
  );
};

export default Navbar;
